module.exports = __webpack_public_path__ + "e83c7cc69bd58b32ab24dbddb592736d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/bell-tower-empty.png
// module id = 315
// module chunks = 0